import { createAction } from '@reduxjs/toolkit';

export const setLoginPageToRegister = createAction<void>('SET_LOGIN_PAGE_TO_REGISTER');
export const setLoginPageToVerify = createAction<void>('SET_LOGIN_PAGE_TO_VERIFY');
export const setLoginPageToLogin = createAction<void>('SET_LOGIN_PAGE_TO_LOGIN');
export const setLoginPageToForgotPassword = createAction<void>('SET_LOGIN_PAGE_TO_FORGOT_PASSWORD');
export const setLoginPageToVerifyForgotPassword = createAction<void>('SET_LOGIN_PAGE_TO_VERIFY_FORGOT_PASSWORD');

export const setLoginPageEmail = createAction<string>('SET_LOGIN_PAGE_EMAIL');
